import React from 'react'
import { custoToolTipStyles } from './styles'

const CustomToolTip = props => {
  return (
    <div className="custom-tooltip-content">
      <p>Día: {props.label}</p>
      <p>Llamadas: {props.payload[0] ? props.payload[0].value : 0}</p>
      <style jsx>{custoToolTipStyles}</style>
    </div>
  )
}

export default CustomToolTip
